import React from 'react';
import SecurityIncidentDetailSection from '../../../sections/AdminDashboard/SecurityFraud/SecurityIncidentDetail';

const SecurityIncidentDetail = () => {
  return <SecurityIncidentDetailSection />;
};

export default SecurityIncidentDetail;

